import React from "react";
import usePortal from "react-useportal";
import { PrescriptionPeriodPicker } from "./index";
import { animated, useTransition } from "react-spring";
import styled from "styled-components";
import { PeriodEnum } from "common/enums/PeriodEnum";

interface PrescriptionPeriodPickerPopOverProps {
  /** Current period selection */
  selection: { number: number; unit: PeriodEnum };
  /** Callback when a value is changed. Name: name of the group that is changed. Value: the new value */
  handleChange?: (name: string, value: any) => void;
  /** Callback when the confirm checkmark button is clicked. */
  handleConfirm?: () => void;
  /** Manage if the picker is shown or not */
  pickerOpen: boolean;
  /** Switch picker open value */
  setPickerOpen: (pickerOpen: boolean) => void;
}

const PrescriptionPeriodPickerPopOver = ({
  selection,
  handleChange,
  handleConfirm,
  pickerOpen,
  setPickerOpen,
}: PrescriptionPeriodPickerPopOverProps) => {
  const { Portal } = usePortal();

  const pickerTransition = useTransition(pickerOpen, null, {
    from: {
      opacity: 0,
      position: "absolute",
      zIndex: 1051,
      top: "100vh",
    },
    enter: { opacity: 1, top: "0", visibility: "visible" },
    leave: {
      opacity: 0,
      top: "100vh",
    },
  });

  return (
    <Portal>
      {pickerTransition.map(
        ({ item, key, props }) =>
          item && (
            <MaximumBackgroundContainer key={key} style={props}>
              <div className="w-100 h-100 d-flex flex-column">
                <div
                  style={{ backgroundColor: "rgb(0, 0, 0, 0.3)" }}
                  className="flex-grow-1"
                  onClick={() => setPickerOpen(false)}
                />
                <PrescriptionPeriodPicker
                  selection={selection}
                  handleChange={handleChange}
                  handleConfirm={() => setPickerOpen(false)}
                />
              </div>
            </MaximumBackgroundContainer>
          )
      )}
    </Portal>
  );
};

const MaximumBackgroundContainer = styled(animated.div)`
  position: fixed;
  top: 0;
  left: 0;
  height: calc(var(--vh, 1vh) * 100);
  width: 100vw;
  z-index: 11;
`;

export default PrescriptionPeriodPickerPopOver;
